import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';

export const getCitationStack = createSelector(
  selectDecoratorsState,
  ({ citationStack }) => citationStack
);

export const getUndoStackIndex = createSelector(
  selectDecoratorsState,
  ({ undoStackIndex }) => undoStackIndex
);

export const getUnNumberedCitationStack = createSelector(
  selectDecoratorsState,
  ({ unNumberedCitationStack }) => unNumberedCitationStack
);

export const getUnNumRefUndoStackIndex = createSelector(
  selectDecoratorsState,
  ({ unNumRefUndoStackIndex }) => unNumRefUndoStackIndex
);

export const getCitationTabIndex = createSelector(
  selectDecoratorsState,
  ({ citationTabIndex }) => citationTabIndex
);
